/**
 * Click-to-load facade for YouTube embeds pasted into RTE content.
 *
 * snippets/rte-youtube-facade.liquid renames src -> data-yt-src so the player
 * never loads on its own. Here we put a poster and a play button in its place,
 * and build the real iframe only once someone asks for it.
 *
 * Re-runs on DOM mutations: collection filtering re-injects the description
 * over AJAX, which brings back un-upgraded iframes.
 */
(function () {
  'use strict';

  if (window.__ytFacadeLoaded) return;
  window.__ytFacadeLoaded = true;

  var PLAY_SVG =
    '<svg viewBox="0 0 68 48" focusable="false" aria-hidden="true">' +
    '<path class="yt-facade__play-bg" d="M66.52 7.74a8.6 8.6 0 0 0-6.04-6.1C55.1.15 34 .15 34 .15s-21.1 0-26.48 1.49a8.6 8.6 0 0 0-6.04 6.1A90.3 90.3 0 0 0 0 24a90.3 90.3 0 0 0 1.48 16.26 8.6 8.6 0 0 0 6.04 6.1C12.9 47.85 34 47.85 34 47.85s21.1 0 26.48-1.49a8.6 8.6 0 0 0 6.04-6.1A90.3 90.3 0 0 0 68 24a90.3 90.3 0 0 0-1.48-16.26z"/>' +
    '<path d="M45 24 27 14v20z" fill="#fff"/>' +
    '</svg>';

  var ALLOW =
    'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';

  function swap(oldNode, newNode) {
    if (oldNode.parentNode) oldNode.parentNode.replaceChild(newNode, oldNode);
  }

  function videoId(src) {
    var match = /\/embed\/([A-Za-z0-9_-]{6,})/.exec(src);
    return match ? match[1] : null;
  }

  function buildPlayer(src, title) {
    var iframe = document.createElement('iframe');
    iframe.src = src + (src.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1';
    iframe.title = title;
    iframe.className = 'yt-facade__frame';
    iframe.setAttribute('allow', ALLOW);
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('frameborder', '0');
    return iframe;
  }

  function upgrade(placeholder) {
    var src = placeholder.getAttribute('data-yt-src');
    placeholder.removeAttribute('data-yt-src');

    var id = src && videoId(src);
    if (!id) return;

    var title = placeholder.getAttribute('title') || 'YouTube video';

    var facade = document.createElement('button');
    facade.type = 'button';
    facade.className = 'yt-facade';
    facade.setAttribute('aria-label', 'Play video: ' + title);

    // maxresdefault is 16:9 but missing on some uploads; hqdefault always
    // exists and object-fit crops its 4:3 letterboxing.
    var poster = document.createElement('img');
    poster.className = 'yt-facade__poster';
    poster.src = 'https://i.ytimg.com/vi/' + id + '/maxresdefault.jpg';
    poster.alt = '';
    poster.loading = 'lazy';
    poster.decoding = 'async';
    poster.addEventListener('error', function fallback() {
      poster.removeEventListener('error', fallback);
      poster.src = 'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg';
    });

    var play = document.createElement('span');
    play.className = 'yt-facade__play';
    play.innerHTML = PLAY_SVG;

    facade.appendChild(poster);
    facade.appendChild(play);

    facade.addEventListener('click', function () {
      swap(facade, buildPlayer(src, title));
    });

    swap(placeholder, facade);
  }

  function init() {
    var pending = document.querySelectorAll('iframe[data-yt-src]');
    for (var i = 0; i < pending.length; i++) upgrade(pending[i]);
  }

  function watch() {
    if (!window.MutationObserver) return;
    new MutationObserver(function () {
      if (document.querySelector('iframe[data-yt-src]')) init();
    }).observe(document.body, { childList: true, subtree: true });
  }

  function start() {
    init();
    watch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
